import { IDatabaseItem } from "../interfaces";

export const COMMON_ITEMS: Array<IDatabaseItem> = [
	{
		title: "nevadent Aku ústní sprcha NMD 3.7 B8",
		price: 699,
		toolsProps: {
			link: "https://www.lidl.cz/p/nevadent-aku-ustni-sprcha-nmd-3-7-d9/p100377876",
			type: "kartacek",
		},
		images: [{
			src: "nevadent.webp",
			large: "nevadent-large.webp",
		}],
	},
];
